import * as XLSX from 'xlsx';

/**
 * Convert an XLSX file to CSV text. With multiple sheets, each sheet is
 * emitted under a "### <SheetName>" marker so nothing is lost in a single file.
 */
export const xlsxToCsv = async (file: File): Promise<string> => {
  const arrayBuffer = await file.arrayBuffer();
  const workbook = XLSX.read(arrayBuffer, { type: 'array' });

  if (workbook.SheetNames.length === 1) {
    return XLSX.utils.sheet_to_csv(workbook.Sheets[workbook.SheetNames[0]]);
  }

  return workbook.SheetNames
    .map((name) => `### ${name}\n${XLSX.utils.sheet_to_csv(workbook.Sheets[name])}`)
    .join('\n\n');
};

/**
 * Convert an XLSX file to JSON text. Single-sheet files yield an array of row
 * objects; multi-sheet files yield an object keyed by sheet name.
 */
export const xlsxToJson = async (file: File): Promise<string> => {
  const arrayBuffer = await file.arrayBuffer();
  const workbook = XLSX.read(arrayBuffer, { type: 'array' });

  const sheetToRows = (name: string) =>
    XLSX.utils.sheet_to_json(workbook.Sheets[name], { defval: '' });

  const data =
    workbook.SheetNames.length === 1
      ? sheetToRows(workbook.SheetNames[0])
      : Object.fromEntries(workbook.SheetNames.map((name) => [name, sheetToRows(name)]));

  return JSON.stringify(data, null, 2);
};
